import { Link } from 'react-router';
import { Icon } from '@/comp/icon/icon';
import { Tooltip } from '@/comp/toolTip/tooltip';
import { AppContext } from '@/context/AppContext';
import { useContext, useMemo } from 'react';
import { tripStartCountdown } from '@/_helper/bookingDetailsHelper';
import DocumentTile from '@/pages/documents';

export const ShowDocuments = () => {
    const { travelType, bookingData, bookingStatus } = useContext(AppContext);

    const isMediated = useMemo(
        () => Object.values(bookingData?.data.frontendParams?.mediatedServices ?? {}).some((service) => service),
        [bookingData]
    );

    const tripStartCountdownValue = useMemo(() => {
        return tripStartCountdown(bookingData?.travelStart);
    }, [bookingData]);

    const showTransferDocument = useMemo(() => {
        if (travelType !== 'package' && travelType !== 'cruise') {
            return false;
        }
        const tariff = bookingData?.data.frontendParams.transferDetails?.tariff.toLowerCase() ?? '';
        return (
            window.$content.mappingTransfer[travelType][tariff] &&
            bookingData?.data.frontendParams.transferDetails !== undefined
        );
    }, [bookingData?.data.frontendParams.transferDetails, travelType]);

    const showSeatReservationDocument = useMemo(() => {
        const seatReservation = bookingData?.data?.frontendParams?.seatReservation ?? {};
        return Object.keys(seatReservation)?.some((key) => seatReservation[key].state === 'OK');
    }, [bookingData?.data?.frontendParams?.seatReservation]);

    const showExcursionDocument = useMemo(
        () => bookingData?.data.frontendParams.excursions?.some((item) => item.state === 'OK'),
        [bookingData]
    );

    if (window.$affiliate || !bookingData) {
        return null;
    }

    return (
        <div className="tab-content-container">
            {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
            <div className="tab-header">
                <h3>
                    Dokumente
                    {window.$browserInfo.device !== 'mobile' && (
                        <Tooltip iconSize={24} placement="right">
                            Das Dokument lässt sich nicht herunterladen? Versuchen Sie es bitte mit einem anderen
                            Webbrowser.
                        </Tooltip>
                    )}
                </h3>
                {window.$browserInfo.device === 'mobile' && (
                    <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                        <Icon name="close" ariaLabel="overlay schließen" />
                    </Link>
                )}
            </div>
            <div className="tab-content">
                {typeof tripStartCountdownValue === 'number' &&
                    tripStartCountdownValue <= 30 &&
                    bookingData.data.frontendParams?.price?.open === 0 && (
                        <>
                            <DocumentTile
                                service="traveldocuments"
                                documentType="travelDocuments"
                                name="traveldocument"
                                label="Reiseunterlagen"
                            />
                            {showTransferDocument && (
                                <DocumentTile
                                    service="transferVoucher"
                                    documentType="transferVoucher"
                                    name="traveldocument"
                                    label="Transfer-Voucher"
                                />
                            )}
                            {showExcursionDocument && (
                                <DocumentTile
                                    service="excursionVoucher"
                                    documentType="excursionVoucher"
                                    name="traveldocument"
                                    label="Ausflugs-Voucher"
                                />
                            )}
                            {showSeatReservationDocument && (
                                <DocumentTile
                                    service="traveldocuments"
                                    documentType="seatReservationVoucher"
                                    name="traveldocument"
                                    label="Sitzplatzreservierungs-Voucher"
                                />
                            )}
                        </>
                    )}

                <DocumentTile service="terms" documentType="terms" name="terms" label="AurumTours AGB" />

                {bookingStatus === 'OK' && (
                    <DocumentTile
                        service="invoiceDocument"
                        documentType="invoice"
                        name="invoicedocument"
                        label="Rechnung"
                    />
                )}

                <DocumentTile
                    service="bookingConfirmation"
                    documentType="couponChattelPaper"
                    name="chattelpaper"
                    label="Sicherungsschein"
                />
                <DocumentTile
                    service="customdocument"
                    documentType="companyDeclaration"
                    name="companyDeclaration"
                    label={isMediated ? 'Formblatt für Pauschalreise' : 'Formblatt '}
                />

                {/* Formblatt kann noch nicht angefragt werden */}
                {isMediated && (
                    <DocumentTile
                        service="customdocument"
                        documentType="companyDeclarationMediated"
                        name="companyDeclarationMediated"
                        label="Formblatt für verbundene Reiseleistungen"
                    />
                )}

                {travelType !== 'hotel' && (
                    <>
                        <DocumentTile
                            service="customdocument"
                            documentType="checklist"
                            name="checklist"
                            label="Checkliste"
                        />
                        <DocumentTile
                            service="customdocument"
                            documentType="travelABC"
                            name="travelABC"
                            label="Reise ABC"
                        />
                    </>
                )}
                {window.$browserInfo.device === 'mobile' && (
                    <div className="info-text">
                        Das Dokument lässt sich nicht herunterladen? Versuchen Sie es bitte mit einem anderen
                        Webbrowser.
                    </div>
                )}
            </div>
        </div>
    );
};
